// EnergyXplorer main route - portfolio view
// tanstack
import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/$accountId/_user/energyxplorer/')({
  component: () => <Navigate to="portfolio/dashboard" replace />,
  staticData: { hideEnergyAnalysisAppBar: true },
});
